import TemplateView from '../../../../../../js/TemplateView'
import InputField from '../../../../../../js/components/InputField'
import ICalFeedLeaveTypesSelector from './ICalFeedLeaveTypesSelector'
import ICalFeedUserSelector from './ICalFeedUserSelector'
import messageResource from '../../../../../../js/messageResource'
import {DEFAULT_LEAVE_TYPE_SELECTION, DEFAULT_SHARED_WITH_USER_SELECTION, DEFAULT_USER_SELECTION} from '../constants'
import {connect} from '../../../../../../js/redux/utils'
import {bindActionCreators} from 'redux'
import {getFeedName, getLeaveTypeSelection, getSharedUserSelection, getUserSelection, isIncludesNotApproved} from '../selectors'
import {getActiveUsersArray, getLeaveTypesArray, getTimeZoneGroupsArray, getUserGroupsArrayWithDefault} from '../../../../../../js/entities/selectors'
import {setFeedLeaveTypeSelection, setFeedName, setIncludeNotApproved, setSharedUserSelection, setUserSelection} from '../actions'

class EditFeedLightBoxContent extends TemplateView {

    constructor({
        setFeedName,
        setUserSelection,
        setSharedUserSelection,
        setFeedLeaveTypeSelection,
        setIncludeNotApproved,
    }) {
        super()

        this.actions = {
            setFeedName,
            setUserSelection,
            setSharedUserSelection,
            setFeedLeaveTypeSelection,
            setIncludeNotApproved,
        }

        this.state = {
            feedName: '',
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            leaveTypes: [],
            userSelection: DEFAULT_USER_SELECTION,
            sharedUserSelection: DEFAULT_SHARED_WITH_USER_SELECTION,
            leaveTypeSelection: DEFAULT_LEAVE_TYPE_SELECTION,
            includeNotApproved: false,
        }

        this.onStatePropertyChanged('feedName', feedName => {
            if (feedName !== this.feedNameInput.getValue()) {
                this.feedNameInput.setValue(feedName)
            }
        })

        this.onAnyStatePropertyChanged(['users', 'userGroups', 'timeZoneGroups'], state => {
            this.userSelector.setState({
                users: state.users,
                userGroups: state.userGroups,
                timeZoneGroups: state.timeZoneGroups,
            })
            this.sharedUserSelector.setState({
                users: state.users,
                userGroups: state.userGroups,
                timeZoneGroups: state.timeZoneGroups,
            })
        })

        this.onStatePropertyDeeplyChanged('userSelection', userSelection => this.userSelector.setState({userSelection}))
        this.onStatePropertyDeeplyChanged('sharedUserSelection', userSelection => this.sharedUserSelector.setState({userSelection}))

        this.onAnyStatePropertyDeeplyChanged(['leaveTypes', 'leaveTypeSelection'], () => {
            this.leaveTypeSelector.setState({
                leaveTypes: this.state.leaveTypes,
                leaveTypeSelection: this.state.leaveTypeSelection,
            })
        })

        this.onStatePropertyChanged('includeNotApproved', includeNotApproved => this.leaveTypeSelector.setState({includeNotApproved}))
    }

    templateHtml() {
        return `<div class='iCalLightBoxContent'>
                    <div class='topContainer'>
                        <div class='feedNameInputWrapper'/>
                    </div>
                    <div class='mainContainer'>
                        <div class='userSelectorWrapper'/>
                        <div class='leaveTypesSelectorWrapper'/>
                        <div class='sharedUserSelectorWrapper'/>
                    </div>
                </div>`
    }

    afterRender() {
        this.feedNameInput = new InputField({
            placeholder: messageResource.getMessage('icalendar.page.lightbox.name.placeholder'),
            additionalClass: 'feedNameInput',
            maxLength: 80,
            onChange: this.actions.setFeedName,
        }).init(this.find('.feedNameInputWrapper'))

        this.userSelector = new ICalFeedUserSelector({
            title: messageResource.getMessage('icalendar.page.lightbox.userselection.description'),
            onSelectionChanged: this.actions.setUserSelection,
        }).init(this.find('.userSelectorWrapper'))

        this.leaveTypeSelector = new ICalFeedLeaveTypesSelector({
            selectorId: 'editFeedLeaveTypeSelector',
            onLeaveTypeSelectionChanged: this.actions.setFeedLeaveTypeSelection,
            onCheckboxClick: this.actions.setIncludeNotApproved,
        }).init(this.find('.leaveTypesSelectorWrapper'))

        this.sharedUserSelector = new ICalFeedUserSelector({
            title: messageResource.getMessage('icalendar.page.lightbox.userselection.shared.description'),
            shared: true,
            onSelectionChanged: this.actions.setSharedUserSelection,
            setAllUsersIfNoneSelected: false,
        }).init(this.find('.sharedUserSelectorWrapper'))
    }

    onShow() {
        this.feedNameInput.focus()
    }
}

export default connect(
    state => ({
        feedName: getFeedName(state),
        users: getActiveUsersArray(state),
        userGroups: getUserGroupsArrayWithDefault(state),
        timeZoneGroups: getTimeZoneGroupsArray(state),
        userSelection: getUserSelection(state),
        sharedUserSelection: getSharedUserSelection(state),
        leaveTypeSelection: getLeaveTypeSelection(state),
        leaveTypes: getLeaveTypesArray(state),
        includeNotApproved: isIncludesNotApproved(state),
    }),
    dispatch => bindActionCreators({
        setFeedName,
        setUserSelection,
        setSharedUserSelection,
        setFeedLeaveTypeSelection,
        setIncludeNotApproved,
    }, dispatch)
)(EditFeedLightBoxContent)



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/edit/EditFeedLightBoxContent.js